import { ConsultantNode } from './consultant-node';
import { ColorConfig } from './../../../color-config';
import { EmployerIds } from '../../../../util/app-constants';
import { Colors } from '../../../../util/colors';

export class TechyConsultantNode extends ConsultantNode {
    protected initdraw() {
        this.svgSymbol = this.organigram.appendSymbol('techSymbol');
        this.strokeWidth = 1.0;
        this.initdrawexperience();
        this.redraw();
        this.svgSymbol.click(this.handleClick);
        this.svgSymbol.mouseover(() => this.handleHover());
        this.svgSymbol.mouseout(() => this.handleOut());
        this.disable();
    }
}
